// Start running when document is ready
document.addEventListener('DOMContentLoaded', function() {
    const linkElements = document.querySelectorAll('.complete-the-look-navigation-link');
    const placementElements = document.querySelectorAll('.complete-the-look-placement');
    
    if (linkElements.length > 0 && placementElements.length > 0) {
        // Content observers to hide and show sections containing nothing - START
        let wasSelectedSet = false;
        placementElements.forEach((element) => {
            const targetElement = element.querySelector('.nosto_element');
            const blockId = element.getAttribute('data-block-id')
            let foundLink;
            linkElements.forEach(link => {
                const linkBlockId = link.getAttribute('data-block-id');
                if (linkBlockId === blockId) foundLink = link;
            })
            
            if (targetElement && foundLink) {
                const callback = (mutationList, observer) => {
                    for (const mutation of mutationList) {
                        if (mutation.type === 'childList') {
                            if (mutation.addedNodes.length > 0) {
                                element.classList.remove('hide-element');
                                foundLink.classList.remove('hide-element');
                                if (!wasSelectedSet && foundLink.innerText === "more you'll love") {
                                    wasSelectedSet = true;
                                    element.classList.add('selected');
                                    foundLink.classList.add('selected');
                                }
                                observer.disconnect();
                            }
                        }
                    }
                };
    
                const observer = new MutationObserver(callback);
    
                observer.observe(targetElement, {
                    childList: true,
                    characterData: true,
                    subtree: true 
                });
            }
        });
        // Content observers to hide and show sections containing nothing - END

        linkElements.forEach(link => {
            link.addEventListener('click', function(event) {
                let element = event.target;
                let blockId = element.getAttribute('data-block-id');
                if (blockId) {
                    let foundPlacement;
                    placementElements.forEach(placement => {
                        placement.classList.remove("selected");
                        let placementBlockId = placement.getAttribute('data-block-id');
                        if (placementBlockId === blockId) {
                            foundPlacement = placement;
                        }
                    });

                    linkElements.forEach(link => {
                        link.classList.remove("selected");
                    });

                    if (foundPlacement) {
                        element.classList.add("selected");
                        foundPlacement.classList.add("selected");
                    }

                    let viewMoreElement = document.querySelector('.complete-the-look-view-cta');
                    if (viewMoreElement) {
                        let viewMoreLink = element.getAttribute('data-nav-link');
                        if (viewMoreLink) {
                            viewMoreElement.setAttribute('onclick', `window.location.href = '${viewMoreLink}'`);
                        }
                    }
                }
            });
        });     
    }
});